export const convertFileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];

      resolve(base64);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export default convertFileToBase64;
